import {Injectable} from "@angular/core";

@Injectable()
export class DateService {

    formatDateToYYYYMMDD(date){
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
        var dd  = date.getDate().toString();
        return yyyy + (mm[1]?mm:"0"+mm[0]) + (dd[1]?dd:"0"+dd[0]);
    }

    formatString(dateString){
        var pattern = /^([0-9]{4})([0-9]{2})([0-9]{2})$/;
        return dateString.replace(pattern, '$3/$2/$1');
    }

    formatStringToDate(dateString){
        var year = dateString.substring(0, 4);
        var month = dateString.substring(4, 6);
        var day = dateString.substring(6, 8);

        var date = new Date(year, month-1, day);

        return date;
    }

    formatStringWithChar(dateString){
        var day = dateString.substring(0, 2);
        var month = dateString.substring(3, 5);
        var year = dateString.substring(6, 10);

        var date = new Date(year, month-1, day);

        return date;
    }

    formatToString(date){
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
        var dd  = date.getDate().toString();
        return yyyy + '-' + (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/date.service.ts